<template>
  <el-dialog
    :visible.sync="visible"
    width="700px"
    title="文件列表"
    append-to-body
    @close="closeDialog"
  >
    <div class="file-list">
      <div v-for="file in fileList" :key="file.uid">
        <div style="margin-bottom: 20px;" v-if="
              ['jpeg', 'png', 'jpg', 'webp', 'gif', 'bmp', 'tiff'].includes(
                file.type
              )
            ">
          <div>
            <span>{{ file.name }}</span>
            <el-button type="text" style="margin-left: 10px" @click="handleDownload(file)">下载</el-button>
          </div>
          <el-image
            style="width: 100px; height: 100px"
            :src="file.url"
            :preview-src-list="srcList"
          >
          </el-image>
        </div>
        <div v-else>
          <div>
            <span>{{ file.name }}</span>
            <el-button type="text" style="margin-left: 10px" @click="handleDownload(file)">下载</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "FileList",
  data() {
    return {
      visible: false,
      previewDialog: false,
      dialogImageUrl: "",
      fileList: [],
      savefileList: [],
      imageList: [],
      srcList: [],
    };
  },
  methods: {
    closeDialog() {
      this.fileList = [];
    },
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.previewDialog = true;
    // },
    handleDownload(file) {
      const data = this.savefileList.find((item) => item.id === file.uid);
      this.preview(data.fileName, data.fileUrl);
    },
    open(ids) {
      this.visible = true;
      this.axios({
        url: "/attachment/list",
        method: "POST",
        data: {
          ids: ids.join(","),
        },
      }).then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          this.savefileList = res.data.data;
          this.fileList = res.data.data.map((item) => {
            return {
              type: item.fileType,
              name: item.fileName,
              url: item.fileUrl,
              uid: item.id,
            };
          });
          this.imageUrl();
        }
      });
    },
    async imageUrl() {
      this.fileList = await Promise.all(
        this.fileList.map(async (item) => {
          const res = await this.axios({
            url: "/attachment/download",
            method: "GET",
            params: {
              fileUrl: item.url,
            },
            responseType: "blob",
          });
          return {
            type: item.type,
            uid: item.uid,
            name: item.name,
            url: URL.createObjectURL(res.data),
          };
        })
      );
      // 过滤所有的图片类型
      this.imageList = this.fileList.filter((item) => {
        if (
          ["jpeg", "png", "jpg", "webp", "gif", "bmp", "tiff"].includes(
            item.type
          )
        ) {
          return item;
        }
      });
      this.srcList = this.imageList.map((item) => item.url);
    },
    preview(name, url) {
      this.axios({
        url: "/attachment/download",
        method: "GET",
        params: {
          fileUrl: url,
        },
        responseType: "blob",
      }).then((res) => {
        let filename = name;
        const link = document.createElement("a");
        let blob = new Blob([res.data], { type: "application/octet-stream" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute(
          "download",
          decodeURI(
            filename.substring(filename.indexOf("=") + 1, filename.length)
          )
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
  },
};
</script>

<style scoped>
::v-deep .el-upload--picture-card {
  display: none;
}
</style>
